import { POSTHOG_FEATURES } from "../constants/feature-flags"
import usePostHogFeatureFlags from "./posthog-feaures"

export default function useCreativeManagementAccess() {
  const isFeatureFlagEnabled = usePostHogFeatureFlags(
    POSTHOG_FEATURES.CREATIVE_MANAGEMENT,
  )

  return { hasAccess: isFeatureFlagEnabled }
}
